module.exports = __webpack_public_path__ + "static/media/Domistic Workers icon.9d54b234.svg";